import React from 'react';
import './LinkPreview.css';
import icon_newpost_delete from '../../../../assets/icons/icon_newpost_delete.svg';

export interface LinkPreviewProps {
  url: string;
  title: string;
  description: string;
  image: string;
  onDelete?: () => void;  // Made optional
}

const LinkPreview: React.FC<LinkPreviewProps> = ({ url, title, description, image, onDelete }) => {
  const truncate = (str: string | null | undefined, maxLength: number) => {
    if (!str) return '';
    if (str.length <= maxLength) return str;
    return str.slice(0, maxLength) + '...';
  };

  const handleClick = (e: React.MouseEvent) => {
    // Prevent click if clicking delete button
    if ((e.target as HTMLElement).closest('.link-preview-delete')) {
      return;
    }
    
    // Ensure URL has https:// prefix
    const secureUrl = url.startsWith('http') ? url : `https://${url}`;
    window.open(secureUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="link-preview-container">
      <div 
        className="link-preview" 
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        {image && <img src={image} alt={title} className="preview-image" />}
        <div className="preview-content">
          <p className="preview-url">{truncate(url, 30)}</p>
          <h3 className="preview-title">{truncate(title, 50)}</h3>
          <p className="preview-description">{truncate(description, 100)}</p>
        </div>
      </div>
      {onDelete && (
        <button 
          className="link-preview-delete" 
          onClick={onDelete}
        >
          <img src={icon_newpost_delete} alt="Delete" />
        </button>
      )}
    </div>
  );
};

export default LinkPreview;
